import merge from "lodash/merge";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { checkWorker } from "~/modules/actions/ActionUtils";
import { sendWorkerTrackingEvent, toCauseMessage } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";
import { createFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";




export interface SetAttributesOptions {
    mergeExisting?: boolean;
}




























export class SetAttributes implements Action<Promise<void>> {
    


    readonly #attributes: Record<any, any>;

    


    readonly #options?: SetAttributesOptions;

    constructor(attributes: Record<any, any>, options?: SetAttributesOptions) {
        this.#attributes = attributes;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const mergeExisting = this.#options?.mergeExisting ?? false;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);

        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        logger.debug("setAttributes called with attributes ", this.#attributes);

        checkWorker(worker, {
            actionName: "SetAttributes",
            moduleName: "actions/Worker",
            logger,
            analytics,
            context,
            event: EVENTS.SetAttributesCompleted,
            extra: {
                mergeExisting
            },
            worker
        });
        const newAttributes = mergeExisting ? merge(taskRouter.worker.attributes, this.#attributes) : this.#attributes;

        try {
            await taskRouter.worker.setAttributes(newAttributes);

            sendWorkerTrackingEvent(EVENTS.SetAttributesCompleted, analytics, worker, { mergeExisting });

            return Promise.resolve();
        } catch (error) {
            const errorMsg = `SetAttributes: Failed to set attributes for current worker ${worker.sid}`;
            sendWorkerTrackingEvent(EVENTS.SetAttributesCompleted, analytics, worker, {
                error: `${errorMsg} (${toCauseMessage(error)})`,
                mergeExisting
            });
            return Promise.reject(
                createFlexSdkError(context)(
                    ErrorCode.FailedToSetCurrentWorkerAttributes,
                    { severity: ErrorSeverity.Error },
                    errorMsg,
                    error
                )
            );
        }
    }
}
